import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { ISalesGroupPromiseLookupService } from "../ISalesGroupPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class SalesGroupPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.SalesGroupImpl>
  implements ISalesGroupPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getSalesGroup(id: CubiqTS.Long): Promise<CubiqTS.SalesGroupImpl>;
}
